document.getElementsByClassName("facebook-settings").length?((function(){$(function(){
    //facebook settings page processor
    var currentStates={};
    var getStates=function()
    {
        var states={};
        $(".facebook-settings .settings").each(function(i,item){
            states[$(item).attr("name")]=$(item).is(":checked");
        });
        return states;
    };

    var setStates=function(states)
    {
        $(".facebook-settings .settings").each(function(i,item){
           $(item).prop('checked', states[$(item).attr("name")]);
        });
        compareStates(currentStates,getStates())?$saveState.$disable():$saveState.$enable();
    };

    var setDefaultStates=function()
    {
        var states={};
        $(".facebook-settings .settings").each(function(i,item){
            states[$(item).attr("name")]=true;
        });
        setStates(states);
        return false;
    };

    var compareStates=function(a,b)
    {
        for(var key in a)
        {
            if(b[key]!=a[key])
                return false;
        }
        return true;
    };

    currentStates=getStates();
    var $saveState=$(".facebook-settings .actions-top");
    $saveState.$enable=function(){
        $saveState.addClass("active");
    };

    $saveState.$disable=function(){
        $saveState.removeClass("active");
    };

    var $saveStateBottom=$(" .actions-bottom");
    $saveStateBottom.$enable=function(){
        $saveStateBottom.addClass("active");
    };

    $saveStateBottom.$disable=function(){
        $saveStateBottom.removeClass("active");
    };

    $(".facebook-settings .settings").on("change",function(){
        compareStates(currentStates,getStates())?$saveState.$disable():$saveState.$enable();
    });

    $(".facebook-settings .cancel-changes").on("click",function(e) {
        e.preventDefault();
        setStates(currentStates);
        return false;
    });

    $(".facebook-settings .save-changes").on("click",function(e) {
        e.preventDefault();
        currentStates=getStates();

        $(".facebook-settings .settings-card").addClass("loading");
        $.post("/facebook/settings/save",currentStates,function(response){
            setStates(currentStates);
            $(".facebook-settings .settings-card").removeClass("loading");
        });
        return false;
    });

    $(".facebook-settings .return-to-default").on("click",function(e){
        e.preventDefault();
        setDefaultStates();
        return false;
    });

    var ValidateUrl=function(url)
    {
        var parser = document.createElement('a');
        parser.href = url;
        if(parser.protocol!="http:" && parser.protocol!="https:")
            return false;

        if( parser.hostname.replace(/facebook.com/mg,"").length>5)
            return false;

        if(parser.pathname.length<2)
            return false;
        return true;
    };

    var $line=$(".check-page-url .bottom-line");

    $(".check-page-url input").on("keyup blur focus",function(e){

        if($(this).is(":disabled"))
            return $line.stop(true).removeClass("has-error").removeClass("valid");
        $(".test-error").slideUp();
        $(".form-page-test").slideDown();
        var val=$(this).val();
        if(val.replace(/[ ]+/mg,"").length==0)
        {
            $line.stop(true).css("right","0%");
            return;
        }

        $line.stop(true).removeClass("has-error").removeClass("valid");
        var urlValid=ValidateUrl(val);
        if(urlValid)
        {
            $line.addClass("valid");
            if(e.keyCode==13)
            {
                $line.css("right","0%");
                StartUrlCheck(val);
                return false;
            }else {
                $line.css("right","100%");
                $line.animate({right: '0%'}, 2000, function () {
                    //run check
                    StartUrlCheck(val);
                });
            }
        }else{
            if(!$(this).is(":focus"))
                $line.addClass("has-error");
        }
    });

    var pageId=0;


    function StartUrlCheck(url)
    {
        $(".check-page-url input").prop("disabled",true);
        $(".form-page-test").slideUp();
        $(".test-process").slideDown(function(){
            $.post("/facebook/settings/check",{url:url},function(response){
                if(response.items.error)
                {
                    $(".check-page-url input").prop("disabled",false);
                    $(".test-process").slideUp();
                    $(".test-error").find("p").text(response.items.error);
                    $(".test-error").slideDown();
                }else{
                    //place information about page
                    $(".test-process").slideUp();
                    $(".test-result").find("h4").text(response.items.data.name);
                    try {
                    $(".test-result").find("img").attr("src",response.items.data.picture.data.url);
                    } catch(E) {

                    }
                    pageId=response.items.data.id;
                    $(".test-result").slideDown();
                }
            });
        });
    }

    $(".go-it-back").on("click",function(){
        $(".test-result").slideUp();
        $(".check-page-url input").prop("disabled",false).val("");
        $(".form-page-test").slideDown();
        return false;
    });

    $(".add-new-page").on("click",function() {
        $(".test-result").slideUp();
        $(".add-new-page-block").addClass("loading");
        $.post("/facebook/settings/add/"+pageId,{},function(resp){
            $(".add-new-page-block").removeClass("loading");
            $(".check-page-url input").prop("disabled",false).val("");
            $(".form-page-test").slideDown();
            AddPageWithTemplate(resp.items.template);
        });
        return false;
    });


    //edit pages
    var Watches={
        
    };
    var $pagesItself=$(".pages-itself");
    var getWatchStates=function()
    {
        var states={};
        $pagesItself.find("input").each(function(i,el){
            states[$(el).attr("name")]=$(el).is(":checked");
        });
        return states;
    };

    var setWatchStates=function(states)
    {
        $pagesItself.find("input").each(function(i,el){
            $(el).prop("checked",states[$(el).attr("name")]);
        });
    };

    Watches=getWatchStates();

    $pagesItself.find("input").on("change",function(){
        if(compareStates(Watches,getWatchStates()))
            $saveStateBottom.$disable();
        else
            $saveStateBottom.$enable();
    });

    $(".pages-enable-all").on("click",function(){
        var states={};
        for(var key in Watches)
            states[key]=true;
        setWatchStates(states);
        if(compareStates(Watches,getWatchStates()))
            $saveStateBottom.$disable();
        else
            $saveStateBottom.$enable();
        $(this).closest(".dropdown").removeClass("open");
        return false;
    });

    $(".pages-disable-all").on("click",function(){
        var states={};
        for(var key in Watches)
            states[key]=false;
        setWatchStates(states);
        if(compareStates(Watches,getWatchStates()))
            $saveStateBottom.$disable();
        else
            $saveStateBottom.$enable();
        $(this).closest(".dropdown").removeClass("open");
        return false;
    });


    $(".cancel-changes-pages").on("click",function(){
        setWatchStates(Watches);
        $saveStateBottom.$disable();
        return false;
    });

    $(".save-changes-pages").on("click",function(){
        Watches=getWatchStates();
        $saveStateBottom.$disable();
        $(".pages-list-card").addClass("loading");
        $.post("/facebook/settings/watchs",Watches,function(response){
            $(".pages-list-card").removeClass("loading");

        });
        return false;
    });

    function AddPageWithTemplate(template) {
        var $el=$(template);
        var nm=$el.find("input").on("change",function(){
            if(compareStates(Watches,getWatchStates()))
                $saveStateBottom.$disable();
            else
                $saveStateBottom.$enable();
        }).attr("name");
        Watches[nm]=true;
        //bindings

        $el.hide();
        $pagesItself.append($el);
        $el.slideDown();
    }
    //remove page click?
});})()):'';